import { Payout } from 'store/api/payout';
import { PayoutType, PayoutStatus } from 'types';

const prepaidTypes: string[] = [
  PayoutType.PrepaidExpense,
  PayoutType.PrepaidReimbursements,
];
// Not counted: refused or written off.
const excludedStatuses: string[] = [
  PayoutStatus.NotApproved,
  PayoutStatus.Lost,
];

const cents = (value?: number | string) => Math.round(Number(value || 0) * 100);

export const isPrepaid = (item: Payout) => prepaidTypes.includes(item.type);

// Totals over every listed record (not only the page shown): paid (with the
// prepaid part), still pending (pending / approved, not paid yet) and both.
export const getReimbursementTotals = (items: Payout[] = []) => {
  let paid = 0;
  let prepaid = 0;
  let pending = 0;
  let counted = 0;
  items.forEach((item) => {
    if (excludedStatuses.includes(item.status)) {
      return;
    }
    counted += 1;
    if (item.status === PayoutStatus.Paid) {
      paid += cents(item.amount);
      if (isPrepaid(item)) {
        prepaid += cents(item.amount);
      }
    } else {
      pending += cents(item.amount);
    }
  });
  return {
    counted,
    paid: paid / 100,
    prepaid: prepaid / 100,
    pending: pending / 100,
    total: (paid + pending) / 100,
  };
};
